/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// React Router components
import { Navigate } from "react-router";

import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import ROUTE_PATHS from "routePaths";

function Basic() {
  const { logout } = useKindeAuth();
  logout();
  return <Navigate to={ROUTE_PATHS.signIn} />;
}

export default Basic;
